import { render, staticRenderFns } from "./BaseLinkExternal.vue?vue&type=template&id=175c0f48&functional=true"
import script from "./BaseLinkExternal.vue?vue&type=script&lang=js"
export * from "./BaseLinkExternal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports